import { useState } from 'react';

export function FaqBlock({ items }: { items: { question: string; answer: string }[] }) {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <div className="space-y-3">
      {items.map((item, idx) => {
        const isOpen = open === idx;
        return (
          <div key={idx} className="rounded-xl border border-border-subtle bg-bg-elevated">
            <button
              className="flex w-full items-center justify-between px-4 py-3 text-left font-medium text-text-primary sm:px-5"
              onClick={() => setOpen(isOpen ? null : idx)}
              aria-expanded={isOpen}
            >
              {item.question}
              <span className="ml-4 text-text-muted">{isOpen ? '−' : '+'}</span>
            </button>
            {isOpen && (
              <div className="px-4 pb-4 text-sm leading-relaxed text-text-secondary sm:px-5">
                {item.answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
